<template>
  <div class="complaintCount">
    <div class="index-header">
      <span class="title">
        <i class="el-icon-caret-right"></i>投诉统计
      </span>
      <span class="other more" @click="jumpMore">
        更多
        <i class="el-icon-d-arrow-right"></i>
      </span>
    </div>
    <div class="complaintCount-main">
      <div style="min-width:200px">
        <div class="myChartTotal-father">
          <div class="myChartTotal" :style="{width: '100px', height: '100px'}">
            <div>
              <h1 @click="jumpTotal">{{data.total}}</h1>
              <br />投诉总数
            </div>
          </div>
        </div>
        <div class="typeTitle">
          <div>
            <span class="fontSize">已处理</span>
          </div>
          <div>
            <span class="fontSize">未处理</span>
          </div>
          <div>
            <span class="fontSize">超时</span>
          </div>
        </div>
        <div class="numTitle">
          <div>
            <span class="fontSize">{{data.done}}</span>
          </div>
          <div>
            <span class="fontSize">{{data.ding}}</span>
          </div>
          <div>
            <span class="fontSize">{{data.timeout}}</span>
          </div>
        </div>
      </div>
      <div class="vertaline">
        <div></div>
      </div>
      <div style="min-width:200px">
        <div class="myChartTotal-father">
          <div
            v-show="!notFound"
            ref="echarts"
            id="myChartComplaintCount"
            :style="{width: '100px', height: '100px'}"
          ></div>
        </div>
        <div v-show="notFound" class="brother">
          <div>
            <svg-icon icon-class="NoWork" class="iconStyle"></svg-icon>
            <br />暂无数据
          </div>
        </div>
        <div v-show="!notFound" class="typeTitle">
          <div>
            <span class="fontSize">满意</span>
          </div>
          <div>
            <span class="fontSize">不满意</span>
          </div>
          <div>
            <span class="fontSize">满意度</span>
          </div>
        </div>
        <div v-show="!notFound" class="numTitle">
          <div>
            <span class="fontSize">{{data.satisfaction}}</span>
          </div>
          <div>
            <span class="fontSize">{{data.unsatisfaction}}</span>
          </div>
          <div>
            <span class="fontSize">{{data.satisfactionPer}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import commonTitle from '@/assets/js/commonTitle.js';
import { mapState } from 'vuex';
import { HomePageControllerSvr } from '@/service/HomePageControllerSvr/HomePageControllerSvr';

export default {
  components: {},
  props: {},
  data() {
    return {
      Position: 'running',
      data: {},
      notFound: false
    };
  },
  computed: {
    ...mapState(['token']),
    mainTitle: () => {
      return commonTitle;
    }
  },
  created() {
    this.HomePageControllerSvr = new HomePageControllerSvr();
  },
  mounted() {
    this.getdata();
  },
  methods: {
    jumpTotal() {
      this.$router.push('/recordMge');
    },
    jumpMore() {
      //this.$router.push('/statisticalAnalysis');
      this.$router.push('/recordMge');
    },
    //
    getdata() {
      this.HomePageControllerSvr.ComplaintStatistics(this.token).then(res => {
        this.data = res;
        if (res.satisfaction + res.unsatisfaction === 0) {
          this.notFound = true;
          return;
        } else if (res.satisfaction === 0) {
          this.data.satisfactionPer = '0%';
        } else {
          this.data.satisfactionPer = res.satisfactionPer;
        }
        this.drawPie();
      });
    },
    drawPie() {
      //投诉统计
      const that = this;
      let myChartComplaintCount = this.$echarts.init(this.$refs.echarts);
      myChartComplaintCount.setOption({
        // tooltip: {
        //   trigger: 'item',
        //   formatter: '{a} <br/>{b}: {c} ({d}%)'
        // },
        graphic: {
          elements: [
            {
              type: 'text',
              left: 'center',
              top: '35%',
              z: 2,
              zlevel: 100,
              style: {
                text: that.data.satisfactionPer,
                x: 100,
                y: 100,
                textAlign: 'center',
                fill: '#333333',
                font: '22px "MicrosoftYaHei", sans-serif '
              }
            },
            {
              type: 'text',
              left: 'center',
              top: '55%',
              z: 2,
              zlevel: 100,
              style: {
                text: '处理满意度',
                x: 100,
                y: 100,
                textAlign: 'center',
                fill: '#333333',
                font: '14px "MicrosoftYaHei", sans-serif'
              }
            }
          ]
        },
        series: [
          {
            name: '访问来源',
            type: 'pie',
            radius: ['85%', '100%'],
            avoidLabelOverlap: false,
            hoverAnimation: false,
            color: ['#0f77f2', '#e2e2e2'],
            label: {
              normal: {
                show: false,
                position: 'center'
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: '15',
                  fontWeight: 'bold'
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: [
              { value: that.data.satisfaction, name: '' },
              { value: that.data.unsatisfaction, name: '' }
            ]
          }
        ]
      });
    }
  }
};
</script>
<style lang="scss">
@import './css/common.scss';
.complaintCount {
  height: 295px;
  background-color: #fff;
  .complaintCount-main {
    height: 210px;
    display: flex;
    justify-content: space-around;
    overflow: hidden;
    .iconStyle {
      font-size: 100px;
      padding-bottom: 20px;
    }
    .brother {
      height: 210px;
      display: flex;
      justify-content: center;
      align-items: center;
      & > div {
        text-align: center;
      }
    }
    .myChartTotal-father {
      display: flex;
      align-items: center;
      justify-content: center;
      .myChartTotal {
        border: 7px #0f77f2 solid;
        border-radius: 50%;
        display: flex;
        margin-top: 30px;
        align-items: center;
        justify-content: center;
        align-content: center;
        div {
          text-align: center;
          h1 {
            cursor: pointer;
            margin: 0;
            color: #333333;
          }
        }
      }
      #myChartComplaintCount {
        margin-top: 30px;
      }
    }
    .typeTitle {
      margin-top: 20px;
      display: flex;
      flex-direction: row;
      min-width: 200px;
      justify-content: space-around;
    }
    .numTitle {
      margin-top: 5px;
      display: flex;
      flex-direction: row;
      min-width: 200px;
      justify-content: space-around;
    }
    .fontSize {
      width: 28px;
      height: 14px;
      font-family: MicrosoftYaHei;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: -1px;
      color: #333333;
    }
    //长竖线
    .vertaline {
      width: 1%;
      height: 210px;
      div {
        width: 1px;
        height: 80%;
        background-color: #e2e2e2;
        margin-top: 21px;
      }
    }
  }
}
</style>